import AlertsPage from './AlertsPage';

export default AlertsPage;
